module.exports = __webpack_public_path__ + "static/media/gp.85556bea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gp.svg
// module id = 132
// module chunks = 0